import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useCookies } from "../hooks/useCookies";
import { API_URL } from "../api";

// Context creation
const AppContext = createContext();

// Custom hook
export const useAppContext = () => useContext(AppContext);

// Context provider component
export const AppContextProvider = ({ children }) => {
  const { getCookie, setCookie, deleteCookie,clearAllCookies} = useCookies();
  const [isPremium, setIsPremium] = useState(getCookie("isPremium") === "true");
  const [ isPremiumStatus, setIsPremiumStatus ] = useState();

  const [userDetails, setUserDetails] = useState({
    first_name: "",
    last_name: "",
    birthday: "",
    gender: "",
    want_gender: "",
  });

  const [locations, setLocations] = useState({
    country: "",
    locations_string: "",
  });

  const [isAdmin, setIsAdmin] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showFullPhoneNumber, setShowFullPhoneNumber] = useState(false);

  const isFetchingSubscriptionInfo = useRef(false);

  // Check if user is admin
  useEffect(() => {
    const userId = getCookie("userId");
    if (userId === "adminlogin") {
      setIsAdmin(true);
    }
  }, [getCookie]);

  const fetchSubscriptionInfo = async () => {
    const token = getCookie("token");

    if (isAdmin || !token || isFetchingSubscriptionInfo.current) return;

    isFetchingSubscriptionInfo.current = true;

    try {
      const response = await fetch(
        `${API_URL}customer/subscription/premium-info`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCookie("isPremium", data.isPremium, data.endsAt);
        setIsPremium(data.isPremium);
        setIsPremiumStatus(data.status)
      } else {
        setCookie("isPremium", false, 0);
        setIsPremium(false);
      }
    } catch (err) {
      console.error("Error fetching subscription info:", err);
    } finally {
      isFetchingSubscriptionInfo.current = false; // Reset after fetching
    }
  };
  // Fetch subscription info
  useEffect(() => {
    fetchSubscriptionInfo();
  }, [isAdmin, getCookie, setCookie]);

  const loginAsAdmin = () => {
    setIsAdmin(true);
    setCookie("userId", "adminlogin", 365);
  };

  const logout = async () => {
    setIsAdmin(false);
    await clearAllCookies()
  };

  const togglePhoneNumber = () => setShowFullPhoneNumber(prev => !prev);

  const updateSubscriptionStatus = async () => {
    await fetchSubscriptionInfo();
  };

  return (
    <AppContext.Provider
      value={{
        locations,
        setLocations,
        phoneNumber,
        setPhoneNumber,
        userDetails,
        setUserDetails,
        isAdmin,
        loginAsAdmin,
        logout,
        togglePhoneNumber,
        showFullPhoneNumber,
        isPremium,
        setIsPremium,
        updateSubscriptionStatus,
        isPremiumStatus
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
